import React, { useState } from "react";
import { ArrowLeft, ArrowRight, CreditCard } from "lucide-react";
import { getBank } from "../data/banks";
import { usePulpayConfig } from "../hooks/usePulpayConfig";

const formatCard = (v) => {
  const digits = (v || "").replace(/\D/g, "").slice(0, 16);
  return digits.replace(/(.{4})/g, "$1 ").trim();
};

export default function CardEntry({ go, user, bankKey, onConfirm }) {
  const bank = getBank(bankKey);
  const config = usePulpayConfig();
  const logoUrl = config.bank_logos?.[bankKey];
  const [rawNumber, setRawNumber] = useState("");

  const formatted = formatCard(rawNumber);
  const digitsOnly = rawNumber.replace(/\D/g, "");

  const holder = user
    ? `${user.firstName || ""} ${user.lastName || ""}`.trim().toUpperCase()
    : "AD SOYAD";

  const canSubmit = digitsOnly.length === 16;

  const handleSubmit = () => {
    if (!canSubmit) return;
    onConfirm({
      bankKey,
      cardNumber: digitsOnly,
      cardMasked: `**** **** **** ${digitsOnly.slice(-4)}`,
      holder,
    });
  };

  if (!bank) {
    return (
      <section className="screen bs-screen">
        <div className="bs-content">Bank tapılmadı</div>
      </section>
    );
  }

  return (
    <section className="screen ce-screen" data-testid="card-entry-screen">
      <button
        className="bs-back"
        onClick={() => go("bank_selection")}
        aria-label="Geri"
        data-testid="ce-back-btn"
      >
        <ArrowLeft size={20} strokeWidth={2.6} />
      </button>

      <div className="ce-content">
        <div className="bs-head">
          <div className="bs-head-badge">
            <CreditCard size={14} strokeWidth={2.8} />
            <span>Kart məlumatları</span>
          </div>
          <h2 className="bs-title">
            <span className="bs-name">{bank.name}</span>
          </h2>
          <p className="bs-sub">Kart nömrənizi və son istifadə tarixini daxil edin.</p>
        </div>

        {/* Live card preview */}
        <div
          className="ce-card"
          data-testid="ce-card-preview"
          style={{
            "--bank-primary": bank.primary,
            "--bank-secondary": bank.secondary,
          }}
        >
          <div className="ce-card-shine" />
          <div className="ce-card-top">
            <div className="ce-card-bank">
              <div className="ce-card-logo">
                {logoUrl ? (
                  <img src={logoUrl} alt={bank.name} onError={(e) => { e.currentTarget.style.display = "none"; }} />
                ) : (
                  <span>{bank.short}</span>
                )}
              </div>
              <span className="ce-card-bank-name">{bank.name}</span>
            </div>
            <div className="ce-card-chip">
              <span /><span /><span /><span />
            </div>
          </div>

          <div className="ce-card-number" data-testid="ce-card-number">
            {digitsOnly.length > 0 ? formatted.padEnd(19, "•") : "•••• •••• •••• ••••"}
          </div>

          <div className="ce-card-bot">
            <div className="ce-card-block">
              <span className="ce-card-lbl">Kart sahibi</span>
              <b className="ce-card-val">{holder || "AD SOYAD"}</b>
            </div>
          </div>
        </div>

        {/* Inputs */}
        <div className="ce-form">
          <label className="ce-field">
            <span>Kart nömrəsi</span>
            <input
              inputMode="numeric"
              placeholder="0000 0000 0000 0000"
              value={formatted}
              onChange={(e) => setRawNumber(e.target.value)}
              data-testid="ce-card-input"
              maxLength={19}
            />
          </label>
        </div>

        <button
          type="button"
          className="ce-submit"
          onClick={handleSubmit}
          disabled={!canSubmit}
          data-testid="ce-submit-btn"
        >
          <span>Kartı təsdiqlə</span>
          <ArrowRight size={18} strokeWidth={2.8} />
        </button>
      </div>
    </section>
  );
}
